import './VolkswagenLogo.scss';
import React from 'react';
import classnames from 'classnames';
import volkswagenLogo from './volkswagen-logo.svg';

const VolkswagenLogo = ({
    classNames,
}) => {
    const classes = classnames('b-volkswagen-logo', classNames);
    return (
        <div className={classes}>
            <img width="150px" src={volkswagenLogo} alt="Volkswagen Logo" data-testid="volkswagen-logo" />
        </div>
    );
};

export default VolkswagenLogo;

